import * as config from './application.json';
import { isTestUser } from '../utils/isInternalUser';

if (config.ENV === 'stage' || isTestUser()) {
  let vConsole;
  import('vconsole').then((module) => {
    const VConsole = module.default;
    vConsole = new VConsole();
  });
}
